<template>
    <div class="footer">
        <div class="landing-footer">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-auto">
                        <div class="category mb-4 mb-md-0">
                            <h2>Legal</h2>
                            <ul>
                                <li>
                                    <a target="_blank" href="https://memod.com/legal/terms-of-service">
                                        Terms of Service
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" href="https://memod.com/legal/privacy-policy">
                                        Privacy Policy
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-md-auto">
                        <div class="category mb-4 mb-md-0">
                            <h2>Founding Creators Program</h2>
                            <ul>
                                <li>
                                    <a target="_blank" href="https://memod.com/founders/faq">
                                        FAQ
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" href="https://memod.com/founders/program-terms-of-service">
                                        Program Terms of Service
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-md-auto ml-lg-auto" />
                </div>
            </div>
        </div>
        <footer class="insights-footer">
            <div class="container">
                <p class="copyright">
                    &copy; {{ currentYear }} Memo’d, Inc. Contact us at <a href="mailto:insights@memod.com">
                        insights@memod.com
                    </a>
                </p>
            </div>
        </footer>
    </div>
</template>

<script>

export default {
    name: "MemodFooter",
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }
}
</script>

<style lang="scss" scoped>
.footer {
    .landing-footer {
        padding: 70px 0;
        background-color: #1C1C1E;

        .category {
            margin-right: 50px;

            h2 {
                color: #f7f7f7;
                margin-bottom: 12px;
                font-size: 21px;
                font-weight: 400;
            }

            ul {
                list-style: none;
                padding-left: 0;
                margin-bottom: 0;

                li {
                    a {
                        color: #b5b5b5;
                        font-size: 18px;
                        line-height: 22px;
                        text-decoration: none;
                        display: block;
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }

    .insights-footer {
        padding: 30px 0;
        background-color: #181818;

        .copyright {
            margin-bottom: 0;
            text-align: center;

            a {
                color: white;
                font-weight: 500;
            }
        }
    }
}
</style>
